<ngx-loading [show]="loading" [config]="{ fullScreenBackdrop : true }"></ngx-loading>


  <div class="container3" style="width:90%; margin-left:auto; margin-right:auto; margin-top:60px">
    <div class="row">
      <div class="left">
        <div class="row">
          <div class='col-12'>
            <div class="card" style="margin-top:1%; padding:4px">
                <span title="City">
                    <h4 style="font-style: open sans ;color: #cb983f">Filter by City:</h4>
                      <hr>
                    <div class="form-group">

                      <div  *ngFor= "let dataa of city">
                        <label>

                        <input  type="checkbox" name="location" [(ngModel)]="dataa.checked" [value] = "dataa.id" [checked] = "dataa.id" (change)="filterCity($event,dataa.id)">
                        <span class="reducesize"> {{dataa.location}}</span>
                      </label>

                      </div>
                      </div>
                    </span>
                <span  *ngIf="location && location.length> 0">
                    <h4 style="font-style: open sans ;color: #cb983f">Filter by Location:</h4>
                      <hr>
                    <div class="form-group">

                      <div  *ngFor= "let dataa of location">


                      <label>

                        <input  type="checkbox" name="location" [(ngModel)]="dataa.checked" [value] = "dataa.id" [checked] = "dataa.id" (change)="filterLocation($event,dataa.id)">
                        <span class="reducesize"> {{dataa.location}}</span>
                      </label>

                      </div>
                      </div>
                    </span>
                <span title="Breed"  *ngIf = "breed && breed.length>0">
                    <h4 style="font-style: open sans ;color: #cb983f">Filter by Breed:</h4>
                    <hr>
                            <div class="form-group">
                                <div  *ngFor= "let dataa of breed">
                                  <label>
                                        <input  type="checkbox" name="breed" [(ngModel)]="dataa.checked" [value] = "dataa.id" [checked] = "dataa.id" (change)="filterBreed($event,dataa.id)">
                                        <span class="reducesize">{{dataa.name}}</span>
                                        </label>
                              </div>
                          </div>

                    </span>



                    <span title="Color">
                     <h4 style="font-style: open sans;color:#cb983f">Filter by Color:</h4>
                        <hr>
                      <div class="form-group">

                        <div  *ngFor= "let dataa of color">
                        <label>

                          <input  type="checkbox" name="color" [(ngModel)]="dataa.checked" [value] = "dataa" [checked] = "dataa" (change)="filterColor($event,dataa)">
                          <span class="reducesize"> {{dataa}}</span>
                        </label>
                      </div>
                    </div>
                    </span>
                    <span title="Age">
                      <h4 style="font-style: open sans; color: #cb983f">Filter By Age</h4>
                        <hr>
                      <div class="form-group">

                          <div  *ngFor= "let dataa of age">
                          <label>

                          <input  type="checkbox" name="flavour" [(ngModel)]="dataa.checked" [value] = "dataa" [checked] = "dataa" (change)="filterAge($event,dataa)">
                          <span class="reducesize"> {{dataa}}</span>
                          </label>
                        </div>
                      </div>
                      </span>



            </div>
          </div>
        </div>

      </div>
      <div class="right">
       <div class="row" *ngIf="(adoption && adoption.length>0);else noadoption">

         <div style="box-shadow:0 1px 1px rgba(0, 0, 0, .5); " class="col-sm-12 col-md-4 col-lg-3 col-xl-3"  *ngFor="let animal of adoption | adoptioncity: cityfilterarray | adoptionbreed: breedfilterarray | adoptionlocation: locationfilterarray | adoptionage: agefilterarray | adoptioncolor: colorfilterarray">
          <div class="card" style="margin-top: 3%;border: 1px solid">
              <img class="card-img-top" style="width:100%; max-height:150px" src="https://passport.petcart.in/images/adoption/{{animal.photo}}" alt="Card image">
          </div>
          <div class="card-body"  style="height:100px ; border: 1px solid;     padding: 5px !important;  background-color:#fff; cursor: pointer">
              <span style="font-style:open sans; color: #9b7544;  overflow-wrap: break-word;" >
                Name:  {{animal.pet_name}}
              </span> <br> <br>
            <span style="font-style:open sans; color: #9b7544;  overflow-wrap: break-word;" >
                {{animal.description | slice: 0: 60}}...
            </span>
          </div>
          <div class="card-footer">
            <div class="row">
              <div class="col-12  text-center">
                  <button class="knowbtn" style="color:#9b7544;cursor:pointer; margin-left: 0px" routerLink="/petadoption/knowme/{{animal.id}}/adoption">Know Me<mat-icon color="accent">favorite</mat-icon></button>
              </div>
            </div>
          </div>
         </div>

       </div>
      </div>
    </div>


          <!--<p *ngIf="contactno">Contact No: {{contactno}}</p>-->
        </div>

        <ng-template #noadoption style="color:red;">
            <mat-card style="margin-top:50px; margin-left:40%"  *ngIf="adoption && adoption.length == 0">
                <div class="row" >
                    <div class="col-sm-12" text-center > 
                        <label style="color: #cb983f;font-size: 25px ">
                            No Result Found  </label>
                    </div>
                  </div>
            </mat-card>


        </ng-template>
